import theme from '../base';
import autoComplete from './autoComplete';
import avatar from './avatar';
import badge from './badge';
import box from './box';
import breadcrumb from './breadcrumb';
import button from './button';
import checkbox from './checkbox';
import collapse from './collapse';
import couponBox from './couponBox';
import divider from './divider';
import dropdown from './dropdown';
import globals from './globals';
import heading from './heading';
import icons from './icons';
import input from './input';
import link from './link';
import modal from './modal';
import price from './price';
import radioButton from './radioButton';
import select from './select';
import storybook from './storybook';
import switchComponent from './switch';
import tabNav from './tabNav';
import tag from './tag';
import text from './text';
import textEditor from './textEditor';
import textarea from './textarea';
import tooltip from './tooltip';

const darkThemeColors = {
  avatar,
  autoComplete,
  badge,
  box,
  breadcrumb,
  button,
  dropdown,
  checkbox,
  collapse,
  couponBox,
  divider,
  globals,
  heading,
  input,
  link,
  modal,
  price,
  radioButton,
  select,
  switchComponent,
  tabNav,
  tag,
  text,
  textarea,
  textEditor,
  tooltip,
  icons,
};

const darkTheme = {
  ...theme,
  /**
   * `colors` are theme specific and should be always used by components
   * instead of base colors, which are only meant to be used directly
   * at storybook docs or by client specific styles
   */
  colors: {
    ...darkThemeColors,
    ...storybook,
    base: {
      ...theme.colors,
    },
  },
};

export default darkTheme;
